import { Control } from 'react-hook-form';
import { AppSelect } from '../../../../../../shared/components/form/select/app-select';
import { NumberTypeEnum } from '../../../../../../types/generated/graphql';
import { ClaimNumbersSchema } from '../schema/claim-numbers.schema';

const GB_NUMBER_TYPE_OPTIONS = [
  { label: 'Local', value: NumberTypeEnum.local },
  { label: 'Mobile', value: NumberTypeEnum.mobile },
  // Removed Toll-Free & National option as it is not currently supported in the claim numbers flow.
  // { label: 'National', value: NumberTypeEnum.national },
  // { label: 'Toll-Free', value: NumberTypeEnum.toll_free },
];

type ClaimNumberTypeSelectProps = {
  control: Control<ClaimNumbersSchema>;
};

export function ClaimNumberTypeSelect({ control }: ClaimNumberTypeSelectProps) {
  return <AppSelect label={'Number Type'} control={control} name="numberType" options={GB_NUMBER_TYPE_OPTIONS} />;
}
